/* PREVIEW ONLY until batch-1 go-live — see storefront-ui README §3 */
/*
  tia-quick-add.js — homepage quick-add "+" (seo-agent, Josh 2026-10-19).
  Rendered only by snippets/tia-home-grid.liquid with quick_add: true; collection,
  search and product pages keep the theme's normal Add to cart.

  One click = POST {cart_add_url}.js with the card's first available variant, qty 1.
  Success: the header cart bubble re-renders (Section Rendering API), the button
  shows a check, a toast offers "View cart", and a polite live region announces it.
  Failure (sold out, quantity limit, network): an inline message on the card plus
  the live region — never silent. No cart drawer opens, so nothing covers the
  delivery-date app on /cart.
  2026-10-19 review follow-ups: the live region exists from page load (a region
  created on the first click can miss that first announcement); adds run one at a
  time through a queue, so two quick "+" taps can never apply an older cart count
  over a newer one; the toast's "View cart" link is a 44px tap target (tia-home.css).
*/
(function () {
  if (window.tiaQuickAddReady) return;
  window.tiaQuickAddReady = true;

  var BUBBLE_SECTION = 'cart-icon-bubble';
  var liveEl = null;
  var toastEl = null;
  var toastTimer = null;

  function liveRegion() {
    if (!liveEl) {
      liveEl = document.createElement('div');
      liveEl.className = 'visually-hidden';
      liveEl.setAttribute('aria-live', 'polite');
      liveEl.setAttribute('aria-atomic', 'true');
      document.body.appendChild(liveEl);
    }
    return liveEl;
  }

  function announce(text) {
    var region = liveRegion();
    region.textContent = '';
    window.setTimeout(function () { region.textContent = text; }, 60);
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-open');
  }

  function armToastTimer() {
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, 6000);
  }

  function showToast(cartUrl) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'th-qa-toast';
      var icon = document.createElement('span');
      icon.className = 'th-qa-toast__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var text = document.createElement('span');
      text.textContent = 'Added to cart';
      var dot = document.createElement('span');
      dot.className = 'th-qa-toast__dot';
      dot.setAttribute('aria-hidden', 'true');
      dot.textContent = '·';
      var link = document.createElement('a');
      link.className = 'th-qa-toast__link';
      link.textContent = 'View cart →';
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'th-qa-toast__close';
      close.setAttribute('aria-label', 'Close');
      close.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
      close.addEventListener('click', hideToast);
      toastEl.append(icon, text, dot, link, close);
      toastEl.addEventListener('mouseenter', function () { window.clearTimeout(toastTimer); });
      toastEl.addEventListener('mouseleave', armToastTimer);
      toastEl.addEventListener('focusin', function () { window.clearTimeout(toastTimer); });
      toastEl.addEventListener('focusout', armToastTimer);
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('.th-qa-toast__link').setAttribute('href', cartUrl);
    // Next frame, so a first-time toast animates in instead of appearing open.
    window.requestAnimationFrame(function () { toastEl.classList.add('is-open'); });
    armToastTimer();
  }

  function sectionInner(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.querySelector('.shopify-section');
    return (section || doc.body).innerHTML;
  }

  function updateBubble(sections) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return Promise.resolve();
    if (sections && sections[BUBBLE_SECTION]) {
      bubble.innerHTML = sectionInner(sections[BUBBLE_SECTION]);
      return Promise.resolve();
    }
    // The add response carried no section HTML: ask the Section Rendering API directly.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=' + BUBBLE_SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data[BUBBLE_SECTION]) bubble.innerHTML = sectionInner(data[BUBBLE_SECTION]);
      })
      .catch(function () { /* the item IS in the cart; a stale count self-heals on the next page */ });
  }

  function showError(btn, message) {
    var zone = btn.closest('.th-qa-zone');
    var msg = zone && zone.querySelector('.th-qa-msg');
    if (msg) {
      msg.textContent = message;
      msg.hidden = false;
      window.clearTimeout(msg._tiaTimer);
      msg._tiaTimer = window.setTimeout(function () { msg.hidden = true; }, 7000);
    }
    announce(message);
  }

  function clearError(btn) {
    var zone = btn.closest('.th-qa-zone');
    var msg = zone && zone.querySelector('.th-qa-msg');
    if (msg) msg.hidden = true;
  }

  // The card photo keeps its own aspect ratio (card-product does not crop to square),
  // so the CSS square zone is only a first guess: match each zone to its photo box.
  function fitZones() {
    document.querySelectorAll('.th-grid__qa').forEach(function (li) {
      var zone = li.querySelector('.th-qa-zone');
      var photo = li.querySelector('.card__inner');
      if (!zone || !photo) return;
      var sync = function () {
        var l = li.getBoundingClientRect();
        var p = photo.getBoundingClientRect();
        if (!p.height) return;
        zone.style.top = (p.top - l.top) + 'px';
        zone.style.left = (p.left - l.left) + 'px';
        zone.style.width = p.width + 'px';
        zone.style.right = 'auto';
        zone.style.height = p.height + 'px';
        zone.style.aspectRatio = 'auto';
      };
      sync();
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(photo);
    });
  }
  fitZones();
  liveRegion();

  // One add at a time: each POST starts after the previous one settled, so the cart
  // bubble is always rendered from the newest cart state.
  var addQueue = Promise.resolve();

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-tia-quick-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var grid = btn.closest('[data-cart-add-url]');
    var addUrl = (grid && grid.getAttribute('data-cart-add-url')) || '/cart/add';
    var cartUrl = (grid && grid.getAttribute('data-cart-url')) || '/cart';
    var title = btn.getAttribute('data-title') || 'Item';
    var variantId = Number(btn.getAttribute('data-variant-id'));

    clearError(btn);
    btn.setAttribute('aria-busy', 'true');
    btn.classList.remove('is-added');

    addQueue = addQueue.then(function () { return addOne(btn, addUrl, cartUrl, title, variantId); });
  });

  function addOne(btn, addUrl, cartUrl, title, variantId) {
    return fetch(addUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: BUBBLE_SECTION,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().catch(function () { return null; }).then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || !data || data.status) {
          showError(btn, (data && (data.description || data.message)) ||
            'Could not add ' + title + ' to the cart. Please try again.');
          return null;
        }
        btn.classList.add('is-added');
        window.clearTimeout(btn._tiaTimer);
        btn._tiaTimer = window.setTimeout(function () { btn.classList.remove('is-added'); }, 2500);
        showToast(cartUrl);
        announce(title + ' added to cart.');
        // The add already succeeded: a bubble-refresh fault must not surface as an add error.
        try {
          return updateBubble(data.sections).catch(function () {});
        } catch (e) {
          return null;
        }
      })
      .catch(function () {
        showError(btn, 'Could not reach the cart. Check your connection and try again.');
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
      });
  }
})();
